import {
  GeoLocation,
  OperationStatus,
  OrganizationalUnit,
  PublicationStatus,
  ShiftCategoriesIdsMap,
  ShiftState,
  TimelineShiftWithActivities,
} from '@wilson/interfaces';
import { CreateNewViaDragAndDropService } from '../create-new-via-drag-and-drop.service';
import { WilsonApp } from '@wilson/interfaces';
import { createFullActivityObject } from '@wilson/non-domain-specific/activities-helpers/services';
import { TranslateService } from '@ngx-translate/core';
import { inject, Injector, runInInjectionContext } from '@angular/core';
import {
  LocalizedDateFormatPipe,
  toDatabaseDateFormat,
} from '@wilson/localization';

interface GenerateDummyShiftParams {
  orgUnit: OrganizationalUnit;
  location: GeoLocation;
  shiftStartDate: Date;
  shiftEndDate: Date;
  userId: string | null;
  activityCategoryId: string;
}

export function generateDummyShift({
  orgUnit,
  location,
  shiftStartDate,
  shiftEndDate,
  userId,
  activityCategoryId,
  injector,
}: GenerateDummyShiftParams & {
  injector: Injector;
}): TimelineShiftWithActivities {
  return runInInjectionContext(injector, () => {
    const translateService = inject(TranslateService);
    const localizedDateFormatPipe = inject(LocalizedDateFormatPipe);
    const shiftCategoryId = ShiftCategoriesIdsMap.Normal;
    const shiftStartDateString = shiftStartDate.toISOString();
    const shiftEndDateString = shiftEndDate.toISOString();

    const shiftName = `${translateService.instant(
      'page.shift',
    )} ${localizedDateFormatPipe.transform(shiftStartDate)}`;

    return {
      id: CreateNewViaDragAndDropService.MOCK_SHIFT_ID,
      comment: '',
      planningComment: null,
      name: shiftName,
      organizationalUnitId: orgUnit?.id as string,
      publicationStatus: PublicationStatus.NotPublished,
      shiftCategoryId: shiftCategoryId,
      startDate: toDatabaseDateFormat(shiftStartDate),
      userId,
      state: ShiftState.NotSubmitted,
      priority: null,
      activities: [
        createFullActivityObject({
          activityCategoryId: activityCategoryId,
          createdFrom: WilsonApp.Portal,
          endDatetime: shiftEndDateString,
          endLocationId: orgUnit.locationId as string,
          endLocation: location,
          jobId: null,
          name: '',
          operationalStatus: OperationStatus.NotStarted,
          professionId: null,
          serviceId: null,
          shiftId: null,
          startDatetime: shiftStartDateString,
          startLocationId: orgUnit.locationId as string,
          startLocation: location,
          viaLocationIds: [],
        }),
      ],

      ignoreStayNecessary: false,
      startDatetime: shiftStartDateString,
      endDatetime: shiftEndDateString,
      deviatedStartDatetime: null,
      deviatedEndDatetime: null,
      reportedStartDatetime: null,
      reportedEndDatetime: null,
      startLocationId: orgUnit.locationId as string,
      endLocationId: orgUnit.locationId as string,
      startLocation: location as GeoLocation & { locationCode: string },
      endLocation: location as GeoLocation & { locationCode: string },
      reportedStartLocationId: null,
      reportedEndLocationId: null,
      reportedStartLocation: null,
      reportedEndLocation: null,
      operationalStatus: OperationStatus.NotStarted,
      projectId: null,
      sharePlanNumber: null,
      maintenanceNumber: null,
      isHighlighted: true,
    };
  });
}
